<template>
  <v-autocomplete
    :hide-details="hideDetails"
    :items="knownEmployeeSelectables"
    :value="value"
    :loading="loading || internalLoading"
    :disabled="disabled || internalLoading"
    label="Mitarbeiter"
    class="select"
    :item-text="getItemText"
    return-object
    overflow
    @input="onInput"
  />
</template>

<script>
import { api, endpoints } from '@/api'
import { mapGetters } from 'vuex'

import {getEmployeeLabel} from '../../filters/Employee'

export default {
  props: {
    value: {
      type: Object,
      default: () => null,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    internalLoading () {
      return this.knownEmployeeSelectablesLoading
    },
    ...mapGetters(['knownEmployeeSelectables', 'knownEmployeeSelectablesLoading']),
  },
  methods: {
    onInput (value) {
      this.$emit('input', value)
    },
    getItemText (employee) {
      return getEmployeeLabel(employee)
    }
  }
}
</script>
